import { Box, Button, IconButton, InputBase, Pagination } from "@mui/material";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { TableMui } from "../../components/mui";
import { useNavigate } from "react-router-dom";
import { Search } from "@mui/icons-material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

export default () => {
  const navigate = useNavigate();
  const handleFieldButtonClick = () => {
    navigate("/advertiser-campaign");
  };
  useEffect(() => {
    document.title = "RollingAdz: Jobs Requests" || "Default Title";
  }, []);
  const data = [
    {
      job_id: "is12cd",
      job_title: "A video of a cat playing with a toy",
      vendor_type: "Photographer",
      date_created: "09-09-2022",
      created_by: "Frank",
      date_accepted: "10-09-2022",
      accepted_by: "Admin",
      detail: "lorem ipsum",
      created_at: "13:30:00",
      assigned_to: "Usman",
      amount: "$200",
      view: <Button onClick={() => handleFieldButtonClick()}>View</Button>,
    },
    {
      job_id: "is12cd2",
      job_title: "A photo of a beautiful landscape",
      vendor_type: "Installer",
      date_created: "09-09-2022",
      created_by: "Alice",
      date_accepted: "10-09-2022",
      accepted_by: "Admin",
      detail: "lorem ipsum",
      created_at: "14:45:00",
      assigned_to: "Emma",
      amount: "$150",
      view: <Button onClick={() => handleFieldButtonClick()}>View</Button>,
    },
    // Add more objects with different dummy data here
    {
      job_id: "is12cd10",
      job_title: "A video of a dancing dog",
      vendor_type: "Installer",
      date_created: "09-09-2022",
      created_by: "Bob",
      date_accepted: "10-09-2022",
      accepted_by: "Admin",
      detail: "lorem ipsum",
      created_at: "10:15:00",
      assigned_to: "Mike",
      amount: "$300",
      view: <Button onClick={() => handleFieldButtonClick()}>View</Button>,
    },
    {
      job_id: "is12cd2",
      job_title: "A photo of a Worst landscape",
      vendor_type: "Driver",
      date_created: "09-09-2022",
      created_by: "Alice",
      date_accepted: "10-09-2022",
      accepted_by: "Admin",
      detail: "lorem ipsum",
      created_at: "14:45:00",
      assigned_to: "Emma",
      amount: "$150",
      view: <Button onClick={() => handleFieldButtonClick()}>View</Button>,
    },
    // Add more objects with different dummy data here
    {
      job_id: "is12cd10",
      job_title: "A video of a dancing Cat",
      vendor_type: "Driver",
      date_created: "09-09-2022",
      created_by: "Bob",
      date_accepted: "10-09-2022",
      accepted_by: "Admin",
      detail: "lorem ipsum",
      created_at: "10:15:00",
      assigned_to: "Nike",
      amount: "$300",
      view: <Button onClick={() => handleFieldButtonClick()}>View</Button>,
    },
  ];
  return (
    <>
      <div
        className=" d-flex justify-content-between align-items-center px-4 col-md-6"
        style={{ backgroundColor: "#f1f1f5", borderRadius: "50px" }}
      >
        <InputBase
          className=""
          sx={{
            ml: 1,
            flex: 1,
            px: 1,
          }}
          placeholder="Search..."
          type="search"
        />
        <Box
          sx={{
            width: "25px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 1,
          }}
        >
          <IconButton
            type="button"
            sx={{
              p: "5px",
              backgroundColor: "#3E4755",
              color: "white",
              "&:hover": {
                backgroundColor: "#3E4755",
                color: "white",
              },
            }}
            aria-label="search"
          >
            <Search style={{ fontSize: 25 }} />
          </IconButton>
        </Box>
      </div>
      <div
        className="d-flex justify-content-
            center"
      >
        <h1 style={{ color: "black" }}>Jobs</h1>
      </div>
      <div>
        <TableMui
          styleTableTh={{
            color: "black",
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
          th={{
            job_id: (
              <>
                Job Id <FilterAltOutlinedIcon />
              </>
            ),
            job_title: (
              <>
                Job Title
                <FilterAltOutlinedIcon />
              </>
            ),
            vendor_type: (
              <>
                Vendor <FilterAltOutlinedIcon />
              </>
            ),
            date_created: (
              <>
                Created on <FilterAltOutlinedIcon />
              </>
            ),
            created_by: (
              <>
                Created By <FilterAltOutlinedIcon />
              </>
            ),
            date_accepted: (
              <>
                Accepted on <FilterAltOutlinedIcon />
              </>
            ),
            accepted_by: (
              <>
                Accepted by <FilterAltOutlinedIcon />
              </>
            ),
            detail: (
              <>
                Details <FilterAltOutlinedIcon />
              </>
            ),
            // created_at: (
            //   <>
            //     Craeted At <FilterAltOutlinedIcon />
            //   </>
            // ),
            // assigned_to: (
            //   <>
            //     Assigned To
            //     <FilterAltOutlinedIcon />
            //   </>
            // ),
            // amount: (
            //   <>
            //     Amouont <FilterAltOutlinedIcon />
            //   </>
            // ),
            view: "Button",
          }}
          td={data}
        />
      </div>
      <div className="d-flex justify-content-end me-5">
        <Pagination count={10} shape="rounded" />
      </div>
    </>
  );
};
